export const LOADME_LOADING: string = 'LOADME_LOADING';
export const LOADME_NOT_LOADING: string = 'LOADME_NOT_LOADING';
